import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RefreshTokenModel } from "@modules/api/refresh-token-model.generated";
import { UserSession } from "@modules/api/user-session.generated";
import { ApiCallUrlService } from "@modules/common/services/api-call-url.service";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class RefreshSessionService {
    constructor(
        private _httpClient: HttpClient,
        private _apiCallUrlService: ApiCallUrlService
    ) { }

    public refreshSession(args: { authenticationToken: string, refreshToken: RefreshTokenModel }): Observable<UserSession> {
        return this._httpClient.post<UserSession>(
            this._apiCallUrlService.getUrl('/Login/RefreshSession/RefreshSession', false),
            args.refreshToken,
            { headers: this.getHeaders(args.authenticationToken) }
        );
    }

    private getHeaders(authenticationToken: string): HttpHeaders {
        const headers: any = {};
        headers['Content-Type'] = 'Application/json';
        headers['Authorization'] = 'Bearer ' + authenticationToken;
        return new HttpHeaders(headers);
    }
}
